__webpack_require__.p = "/react_flippcards/";